import React from 'react';
import Typography from '@primitives/Typography/Typography';
import { Button } from '@primitives';
import styles from './WhatsappShareGuide.module.scss';
import updateExtensionDemoVideoUrl from '@cp/assets/videos/whatsapp-screen-share-guide.mp4';

interface WhatsappShareGuideProps {
  onCancel: () => void;
  onProceed: () => void;
}

const WhatsappShareGuide = ({ onCancel, onProceed }: WhatsappShareGuideProps) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <Typography variant="h4" className={styles.title}>
          Share audio to use Whatsapp call
        </Typography>

        <div className={styles.imageSection}>
          <Typography variant="p4" className="text-[var(--grayscale-2)]">
            Share whatsapp chrome tab and audio to proceed
          </Typography>

          <div className={styles.imageWrapper}>
            <video width={'100%'} height={450} autoPlay controls>
              <source src={updateExtensionDemoVideoUrl} type="video/mp4" />
            </video>
          </div>
        </div>
        <div className={styles.actions}>
          <Button variant="secondary" onClick={onCancel} fullWidth>
            Cancel
          </Button>
          <Button onClick={onProceed} fullWidth>
            Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(WhatsappShareGuide);
